export class GoogleAnalyticsEvent {
  private readonly event = 'GAEvent';

  constructor(
    public readonly eventCategory: string,
    public readonly eventAction: string,
    public readonly eventLabel?: string,
    public readonly eventValue?: string,
  ) {}
}
